import { Component, inject, signal } from '@angular/core';
import { WishListDataService } from '../../../services/witsh-list-data.service';
import { I18nPluralPipe } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { SvgIconComponent } from '@utilities/components/svg-icon/svg-icon.component';

@Component({
  selector: 'wish-list-nav',
  imports: [I18nPluralPipe, RouterLink, SvgIconComponent],
  templateUrl: './wish-list-nav.component.html',
})
export class WishListNavComponent {
  private router = inject(Router);

  wishListDataService = inject(WishListDataService);
  wishListMap = signal({
    '=1': 'Nueva',
    other: 'Nuevas',
  });

  navigateToWishList(wishListId: string) {
    this.router.navigateByUrl('wishlist', {
      state: { selectedWishListId: wishListId },
    });
  }
}
